import React, { Component } from 'react';

import { Form, Input } from 'antd';

const TextArea = Input.TextArea;
const FormItem = Form.Item;

class InputField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value
        };
    }

    handleChange(data) {
        const name = this.props.name;

        this.setState({
            value: data[name]
        });

        if(this.props.handleChange) {
            this.props.handleChange(data);
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.hasOwnProperty('value')) {
            this.setState({
                value: nextProps.value
            });
        }
    }

    render() {
        const { style, label, getFieldDecorator, name, rules, type, actionDisable, zgcpEnter, maxLength } = this.props;
        const { value } = this.state;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 16 },
            },
        };
        return (
            <FormItem label={label} style={{marginTop: 5}} {...zgcpEnter?formItemLayout:''}>
                {
                    getFieldDecorator ? (
                        getFieldDecorator(name, {
                            initialValue: value,
                            rules: rules || [{
                                required: true,
                                message: '请输入'+ (label || ""),
                            }],
                        })(
                            <TextArea
                                value={value}
                                placeholder='请输入...'
                                type={type || 'text'}
                                maxLength={maxLength || 1000}
                                disabled={actionDisable}
                                style={style || {width: 370, height: 100}}
                                onChange={(event) => {
                                    this.handleChange({ 
                                        [name]: event.target.value
                                    });
                                }}
                            ></TextArea>
                        )
                    ) : (
                        <TextArea
                            value={value}
                            placeholder='请输入...'
                            type={type || 'text'}
                            maxLength={maxLength || 1000}
                            disabled={actionDisable}
                            style={style || {width: 370, height: 100}}
                            onChange={(event) => {
                                this.handleChange({ 
                                    [name]: event.target.value
                                });
                            }}
                        ></TextArea>
                    )
                }
                
            </FormItem>
        );
    }
}

export default InputField;